import { Injectable } from '@angular/core';
import { HelpSiteDataDTO } from '../../../../../common/dto/help-site.dto';
import { ServerUrls } from '../../../../../common/dto/server-urls';
import { CoolHttp } from '@angular-cool/http';
import { Language } from '../../../../../common/dto/languages.dto';

@Injectable()
export class HelpSiteService {
  constructor(private _http: CoolHttp) {
  }

  public async getHelpSiteDataAsync(language: Language): Promise<HelpSiteDataDTO> {
    return await this._http.getAsync(ServerUrls.HelpSite._.Data._.Get.absoluteUrl, {
      params: {
        [ServerUrls.HelpSite._.Data._.Get.queryParams.language]: language,
      },
    });
  }
}
